module.exports = __webpack_public_path__ + "static/media/noun_Shopping Cart_remove-white.c4d19e91.svg";